import React from 'react';

export const Skeleton: React.FC<{ width?: string; height?: string; style?: React.CSSProperties }> = ({ width = '100%', height = '1.2em', style }) => (
  <div className="skeleton" style={{ width, height, ...style }} />
);
